import React, {useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
//import './Navbar.css';

function SharedSidebar() {
    const [click, setClick] = useState(false);
    const [button, setButton] = useState(true);

    const handleClick = () => setClick(!click);
    const closeMobileMenu = () => setClick(false);

    // Hamburger menu
    const showButton = () => {
        if(window.innerWidth <= 960) {
            setButton(false);
        } else {
            setButton(true);
        }
    };

    useEffect(() => {
        showButton();
    }, []);

    // For different size screens
    window.addEventListener('resize', showButton);

    return (
        <>
            <nav className="navbar">
                <div className="navbar-container">
                    <Link to="/" className ="navbar-logo" onClick={closeMobileMenu}>
                        WOBB
                    </Link>
                    <div className='menu-icon' onClick={handleClick}>
                        <i className={click ? 'fas fa-times' : 'fas fa-bars'}></i>
                    </div>
   
                    <ul className={click ? 'nav-menu active' : 'nav-menu'}>
                        <li className='nav-item'>
                            <Link to='/' className='nav-links' onClick={closeMobileMenu}>
                                Blog
                            </Link>
                        </li>
                        <li className='nav-item'>
                            <Link to='/presskit' className='nav-links' onClick={closeMobileMenu}>
                                Press Kit
                            </Link>
                        </li>
                    </ul>
                </div>
            </nav>
        </>
    )
}

export default SharedSidebar;